import { createContext, useContext } from 'react';

export type PsapPortalConfigurationDto = {
  appName: string;
  showAppNameInNavigation: boolean;
  logoFolderPath: string;
  themeColor: string;
  psapPortalFeatures: { allowEmergencyCallNotification: boolean } & Record<string, unknown>;
} & Record<string, unknown>;

export type PsapConfigurationDto = {
  id: string;
  psapPortalConfiguration: PsapPortalConfigurationDto;
  videoRecordingEnabled: boolean;
  appleEedAllowMedicalData: boolean;
  notificationConfiguration: { pushNotificationConfiguration?: unknown } & Record<string, unknown>;
};

const PsapConfigurationContext = createContext<PsapConfigurationDto | null>(null);

export const PsapConfigurationContextProvider = PsapConfigurationContext.Provider;

export function usePsapConfiguration(): PsapConfigurationDto {
  const configuration = useContext(PsapConfigurationContext);
  if (!configuration) {
    throw new Error('usePsapConfiguration must be used within PsapConfigurationProvider');
  }

  return configuration;
}
